import { dedupeFiles } from 'v3/utils/fileKey';
import { shouldShowSubQuestion } from 'v3/pages/Checklist/CheckListSingle/utils/questionTree';

function getLocalFiles(question) {
  return Array.from(question?.attachment?.files || []);
}

/**
 * Monta a lista de arquivos a enviar, uma entrada por pergunta.
 * Ignora subperguntas ocultas, deduplica perguntas repetidas (por id)
 * e arquivos repetidos dentro da mesma pergunta.
 */
export function collectFilesToUpload(groupedQuestions = []) {
  const entries = [];
  const seenQuestionIds = new Set();

  function add(question) {
    if (!question || seenQuestionIds.has(question.id)) return;
    const files = dedupeFiles(getLocalFiles(question));
    if (!files.length) return;
    seenQuestionIds.add(question.id);
    entries.push({ questionId: question.id, files });
  }

  (groupedQuestions || []).forEach(({ parent, subQuestions = [] }) => {
    add(parent);
    subQuestions
      .filter((sub) => shouldShowSubQuestion(parent, sub))
      .forEach(add);
  });

  return entries;
}

export function appendFilesToFormData(formData, entries = []) {
  let idx = 0;
  entries.forEach(({ questionId, files }) => {
    files.forEach((file) => {
      formData.append(`file${idx}@questionId=${questionId}`, file);
      idx += 1;
    });
  });
  return idx;
}
